import React from "react";

export const WalletIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.55 2.09828L10.525 2.15662L8.1083 7.76495H5.7333C5.16663 7.76495 4.62497 7.88162 4.1333 8.08995L5.59163 4.60662L5.62497 4.52328L5.6833 4.38995C5.69997 4.33995 5.71663 4.28995 5.74163 4.24828C6.8333 1.72328 8.06663 1.14828 10.55 2.09828Z"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0417 7.93197C14.6667 7.8153 14.2667 7.7653 13.8667 7.7653H8.1084L10.5251 2.15697L10.5501 2.09863C10.6751 2.1403 10.7917 2.19863 10.9167 2.24863L12.7584 3.02363C13.7834 3.44863 14.5001 3.8903 14.9334 4.42363C15.0167 4.52363 15.0834 4.6153 15.1417 4.72363C15.2167 4.8403 15.2751 4.95697 15.3084 5.08197C15.3417 5.15697 15.3667 5.23197 15.3834 5.29863C15.6084 5.99863 15.4751 6.85697 15.0417 7.93197Z"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9346 11.8318V13.4568C17.9346 13.6235 17.9263 13.7901 17.9179 13.9568C17.7596 16.8651 16.1346 18.3318 13.0513 18.3318H6.55127C6.35127 18.3318 6.15127 18.3151 5.9596 18.2901C3.3096 18.1151 1.89294 16.6985 1.71794 14.0485C1.69294 13.8568 1.67627 13.6568 1.67627 13.4568V11.8318C1.67627 10.1568 2.69294 8.71514 4.14294 8.09014C4.64294 7.8818 5.17627 7.76514 5.74294 7.76514H13.8763C14.2846 7.76514 14.6846 7.82347 15.0513 7.9318C16.7096 8.44014 17.9346 9.99014 17.9346 11.8318Z"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5915 4.60693L4.13317 8.09027C2.68317 8.71527 1.6665 10.1569 1.6665 11.8319V9.39027C1.6665 7.0236 3.34984 5.0486 5.5915 4.60693Z"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9322 9.38988V11.8315C17.9322 9.99821 16.7155 8.43988 15.0488 7.93988C15.4822 6.85654 15.6072 6.00654 15.3988 5.29821C15.3822 5.22321 15.3572 5.14821 15.3238 5.08154C16.8738 5.88154 17.9322 7.52321 17.9322 9.38988Z"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
